export const categories = [
  {
    name: 'All',
    value: 'all',
  },
  {
    name: 'Accessories',
    value: 'accessories',
  },
  {
    name: 'Adult',
    value: 'adult',
  },
  {
    name: 'Art & Collectibles',
    value: 'art-collectibles',
  },
  {
    name: 'Bags & Purses',
    value: 'bags-purses',
  },
  {
    name: 'Bath & Beauty',
    value: 'bath-beauty',
  },
  {
    name: 'Books, Movies & Music',
    value: 'books-movies-music',
  },
  {
    name: 'Christmas',
    value: 'christmas',
  },
  {
    name: 'Clothing',
    value: 'clothing',
  },
  {
    name: 'Craft Supplies & Tools',
    value: 'craft-supplies-tools',
  },
  {
    name: 'Electronics & Accessories',
    value: 'electronics-accessories',
  },
  {
    name: 'Halloween',
    value: 'halloween',
  },
  {
    name: 'Home & Living',
    value: 'home-living',
  },
  {
    name: 'Jewelry',
    value: 'jewelry',
  },
  {
    name: 'Paper & Party Supplies',
    value: 'paper-party-supplies',
  },
  {
    name: 'Pet Supplies',
    value: 'pet-supplies',
  },
  {
    name: 'Shoes',
    value: 'shoes',
  },
  {
    name: 'SVG',
    value: 'svg',
  },
  {
    name: 'Toys & Games',
    value: 'toys-games',
  },
  {
    name: 'Vintage',
    value: 'vintage',
  },
  {
    name: 'Weddings',
    value: 'weddings',
  },
];

export const pod = [
  {
    name: 'Embroidery',
    value: 'embroidery',
  },
  {
    name: 'Hoodies',
    value: 'hoodies',
  },
  {
    name: 'Mugs',
    value: 'mugs',
  },
  {
    name: 'Phone Cases',
    value: 'phone-cases',
  },
  {
    name: 'Shirts',
    value: 'shirts',
  },
  {
    name: 'Stickers',
    value: 'stickers',
  },
  {
    name: 'Sweatshirts',
    value: 'sweatshirts',
  },
  {
    name: 'Tote Bags',
    value: 'tote-bags',
  },
];
